import { Component, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Store } from '@ngxs/store';
import { Apollo, gql } from 'apollo-angular';
import { IonDateTimePickerComponent } from 'src/app/components/ion-date-time-picker/ion-date-time-picker.component';
import { ErrorAlertVal } from 'src/app/model/Response.model';
import { AlertModalStatus } from 'src/app/model/alert-modal.model';
import { BillDetail } from 'src/app/store/bill/bill.action';
import { BASE_CONFIG } from 'src/app/util/base-settings';
import { APP_ROUTES, COMPONENT_NAME, CategoryFilter, DATE_TIME_FORMAT, PAYMENT_STATUS, RepeatInterval, ToastTypes } from 'src/app/util/constants';
import { DateFunctions } from 'src/app/util/date-functions';
import { QueryFunction } from 'src/app/util/query';
import { UtilFunctions } from 'src/app/util/util'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  billsList: any[] = [];
  searchBy: string[] = [];
  formattedList: any[] = [];
  upcomingList: any[] = [];
  overdueList: any[] = [];
  unpaidList: any[] = [];
  paidList: any[] = [];
  rawUpcomingList: any[] = [];
  rawOverdueList: any[] = [];
  rawUnpaidList: any[] = [];
  rawPaidList: any[] = [];
  categorySliderList: any[] = [];
  billStatus: string = '';
  selDates: string[];
  minDate: string;
  maxDate: string;
  startDate: any;
  endDate: any;
  defaultStartDate: any;
  defaultEndDate: any;
  showLoading: boolean = false;
  paymentStatus: any = PAYMENT_STATUS.UNPAID;
  openBillModal: boolean = false;
  selBill: any;
  sourceObj: any;
  isRepeatBill: boolean = false;
  alertMsg: ErrorAlertVal | string;
  modalStatus: AlertModalStatus;
  showAlertModal: boolean = false;
  searchBoxValue: string = '';
  selStartDate: string = null;
  selEndDate: string = null;
  showSearchClearBtn: boolean = false;
  showCatClearBtn: boolean = false;
  showDateClearBtn: boolean = false;
  timeoutId: undefined | ReturnType<typeof setTimeout>;
  paidMinDate: string = "1970-01-01";
  paidMaxDate: string;
  AppRoutes = APP_ROUTES;
  timeFormat = DATE_TIME_FORMAT ;
  constructor(
    private util: UtilFunctions,
    private dateFunctions: DateFunctions,
    private apollo: Apollo,
    private modalController: ModalController,
    private store: Store,
    private queryFunction: QueryFunction,
    private popoverController: PopoverController
  ) { }

  ngOnInit() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('ngOnInit');
      this.assignStatus(true);
    } catch (error) {
      this.util.logFunc('ngOnInit', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  assignStatus(fromOnInit?: boolean) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('assignStatus');
      this.showSearchClearBtn = false;
      this.showCatClearBtn = false;
      this.showDateClearBtn = false;
      this.upcomingList = [];
      this.overdueList = [];
      this.unpaidList = [];
      this.paidList = [];
      if (fromOnInit) {
        let dateOfMonth = this.dateFunctions.getStartAndEndDateOfMonth(new Date());
        this.startDate = this.dateFunctions.formatDate(dateOfMonth.start,DATE_TIME_FORMAT.API_DATE_FORMAT1);
        this.endDate = this.dateFunctions.formatDate(dateOfMonth.end,DATE_TIME_FORMAT.API_DATE_FORMAT1);
        this.defaultStartDate = this.startDate;
        this.defaultEndDate = this.endDate;
      }
      if (this.selStartDate === this.startDate && this.selEndDate === this.endDate) {
        this.toGetUpcomingLs();
        this.toGetOverdueLs();
        this.toGetUnpaidLs();
        this.toGetPaidLs();
      }
      this.selStartDate = this.startDate;
      this.selEndDate = this.endDate;
      this.minDate = "2000";
      this.maxDate = "2050";
      this.paidMaxDate = this.dateFunctions.formatDate(new Date(),DATE_TIME_FORMAT.API_DATE_FORMAT1);
    } catch (error) {
      this.util.logFunc('assignStatus', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  toGetUpcomingLs()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toGetUpcomingLs');
      // this.startDate = this.dateFunctions.formatDate(new Date(),DATE_TIME_FORMAT.API_DATE_FORMAT1);            //Issue: 1704
      // this.endDate = this.dateFunctions.getNext30Days();
      this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.UNPAID, APP_ROUTES.UPCOMING);
    } catch (error) {
      this.util.logFunc('toGetUpcomingLs', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  toGetOverdueLs()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toGetOverdueLs');
      // this.startDate=this.dateFunctions.getLast30Days();
      // this.endDate = this.dateFunctions.formatDate(new Date(),DATE_TIME_FORMAT.API_DATE_FORMAT1);
      this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.UNPAID, APP_ROUTES.OVERDUE);
    } catch (error) {
      this.util.logFunc('toGetOverdueLs', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  toGetUnpaidLs()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toGetUnpaidLs');
      // let dateOfMonth=this.dateFunctions.getStartAndEndDateOfMonth(new Date());
      // this.startDate=this.dateFunctions.formatDate(dateOfMonth.start,DATE_TIME_FORMAT.API_DATE_FORMAT1);
      // this.endDate = this.dateFunctions.formatDate(dateOfMonth.end,DATE_TIME_FORMAT.API_DATE_FORMAT1);
      this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.UNPAID, APP_ROUTES.UNPAID);
    } catch (error) {
      this.util.logFunc('toGetUnpaidLs', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  toGetPaidLs()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toGetPaidLs');
      // let dateOfMonth=this.dateFunctions.getStartAndEndDateOfMonth(new Date());
      // this.startDate=this.dateFunctions.formatDate(dateOfMonth.start,DATE_TIME_FORMAT.API_DATE_FORMAT1);
      // this.endDate = this.dateFunctions.formatDate(dateOfMonth.end,DATE_TIME_FORMAT.API_DATE_FORMAT1);
      this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.PAID, APP_ROUTES.PAID);
    } catch (error) {
      this.util.logFunc('toGetPaidLs', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  emitOnSearch(event: any) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('emitOnSearch');
      if (event) {
        this.showSearchClearBtn = event.searchKey ? true : false;
        this.searchBoxValue = event.searchKey;
        this.upcomingList = event.searchList.upcoming;
        this.overdueList = event.searchList.overdue;
        this.unpaidList = event.searchList.unpaid;
        this.paidList = event.searchList.paid;
      }
    } catch (error) {
      this.util.logFunc('toAssignInvoiceChartDetails', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onEmitDate(event) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onEmitDate');
      if (event) {
        this.searchBoxValue = '';
        this.upcomingList = [];
        this.overdueList = [];
        this.unpaidList = [];
        this.paidList = [];
        this.startDate = this.dateFunctions.formatDate(event.start, DATE_TIME_FORMAT.API_DATE_FORMAT1);
        this.endDate = this.dateFunctions.formatDate(event.end, DATE_TIME_FORMAT.API_DATE_FORMAT1) ;
        if (this.defaultStartDate !== this.startDate || this.defaultEndDate !== this.endDate) {
          this.showDateClearBtn = true;
        } else {
          this.showDateClearBtn = false;
        }
        // this.selStartDate = this.startDate;
        // this.selEndDate = this.endDate;
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);                       //To cancel Double Execution from Clear Filter to avoid Duplicate in Bills List
        }
        this.timeoutId = setTimeout(() => {
          this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.UNPAID, APP_ROUTES.UPCOMING);
          this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.UNPAID, APP_ROUTES.OVERDUE);
          this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.UNPAID, APP_ROUTES.UNPAID);
          this.getBills(this.startDate, this.endDate, PAYMENT_STATUS.PAID, APP_ROUTES.PAID);
        });
      }
    } catch (error) {
      this.util.logFunc('onEmitDate', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onAddBill() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onAddBill');
      this.util.navigate(APP_ROUTES.ADD_BILL);
    } catch (error) {
      this.util.logFunc('onAddBill', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onChangeCategory(event) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onChangeCategory');
      this.showCatClearBtn = event.categoryid == CategoryFilter.All ? false : true;
      this.upcomingList = this.toFilterCategory(this.rawUpcomingList, event.categoryid);
      this.overdueList = this.toFilterCategory(this.rawOverdueList, event.categoryid);
      this.unpaidList = this.toFilterCategory(this.rawUnpaidList, event.categoryid);
      this.paidList = this.toFilterCategory(this.rawPaidList, event.categoryid);
      this.sourceObj = this.toFormatLs();
    } catch (error) {
      this.util.logFunc('onChangeCategory', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  toFilterCategory(pBillList, pCategoryId) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toFilterCategory');
      let categoryLs = [];
      if (pCategoryId) {
        if(pCategoryId ==CategoryFilter.All) {
          categoryLs = pBillList;
        } else {
          for (let i = 0; i < pBillList.length; i++) {
            if (pCategoryId == pBillList[i].bill.category.categoryid) {
              categoryLs.push(pBillList[i]);
            }
          }
        }
      }
      return categoryLs;
    } catch (error) {
      this.util.logFunc('toFilterCategory', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  getBills(pFromDate, pToDate, pPaymentStatus, pPaymentType) {
    let retValue;
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('getBills');
      this.showLoading = true;
      let billsQuery = `query getTwoFiltterBills {
      __typename
    billsreminder_bill_details(where: {_and: [{bill_datetime: {_gte: "${pFromDate}"}}, {bill_datetime: {_lte: "${pToDate}"}}, {payment_status: {_neq: ${pPaymentStatus}}}]}, order_by: {bill_id: desc, bill_datetime: asc}, limit: 10) {
        __typename
        id
        bill_id
        bill_datetime
        amount
        paid_amount
        user_id
        paid_date
        payment_status
        bill {
          __typename
          bill_id
          bill_type
          notes
          payment_url
          bill_datetime_until
          repeat_type
          future_date
          repeat_interval
          category {
            __typename
            categoryid
            categoryname
          }
        }
      }
      billsreminder_category {
        __typename
        categoryid
        categoryname
      }
      billsreminder_app_setting {
        __typename
        setting_id
      }
    }`;
    this.apollo
        .subscribe({
          query: gql`
            ${billsQuery}
          `,
          errorPolicy: 'all',
        })
        .subscribe((result: any) => {
          if (result && result.data) {
            this.billsList = this.util.cloneDeep(
              result.data.billsreminder_bill_details
            );
            switch (pPaymentType) {
              case APP_ROUTES.UPCOMING:
                this.toFilterUpcomingLs();
                break;

              case APP_ROUTES.OVERDUE:
                this.toFilterOverdueLs();
                break;

              case APP_ROUTES.UNPAID:
                this.unpaidList = this.util.cloneDeep(this.billsList);
                break;

              case APP_ROUTES.PAID:
                this.paidList = this.util.cloneDeep(this.billsList);
                break;
            
              default:
                break;
            }
            this.toGetRawList();
            this.sourceObj = this.toFormatLs();
            this.toGetCategoryList(
              this.util.cloneDeep(result.data.billsreminder_category)
            );
          } else if (result && result.errors) {
            this.util.handleErrorStatus(
              COMPONENT_NAME.DASHBOARD_PAGE,
              'getBills',
              result.errors[0].message.toString()
            );
            this.util.errorHandling(result.errors);

          }
          this.showLoading = false;
        });
    } catch (error) {
      this.showLoading = false;
      this.util.logFunc('getBills', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
    return retValue;
  }

  toFormatLs() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toFormatLs');
      let searchObj = {upcoming: [], overdue: [], unpaid: [], paid: []};
      searchObj.upcoming = this.upcomingList;
      searchObj.overdue = this.overdueList;
      searchObj.unpaid = this.unpaidList;
      searchObj.paid = this.paidList;
      return searchObj;
    } catch (error) {
      this.util.logFunc('toFormatLs', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  toGetRawList() {                                                      //to maintain separate list for category filter
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toGetRawList');
      this.rawUpcomingList = this.util.cloneDeep(this.upcomingList);
      this.rawOverdueList = this.util.cloneDeep(this.overdueList);
      this.rawUnpaidList = this.util.cloneDeep(this.unpaidList);
      this.rawPaidList = this.util.cloneDeep(this.paidList);
    } catch (error) {
      this.util.logFunc('toGetRawList', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  private toFilterOverdueLs() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toFilterOverdueLs');
      const today = new Date(this.dateFunctions.formatDate(new Date(), DATE_TIME_FORMAT.COMMON_DATE_FORMAT2));
      for (let i = 0; i < this.billsList.length; i++) {
        if (new Date(this.dateFunctions.formatDate(new Date(this.billsList[i].bill_datetime), DATE_TIME_FORMAT.COMMON_DATE_FORMAT2)) < today) {
          this.overdueList.push(this.billsList[i]);
        }
      }
      this.overdueList = this.util.cloneDeep(this.overdueList);
    } catch (error) {
      this.util.logFunc('toFilterOverdueLs', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  private toFilterUpcomingLs() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toFilterUpcomingLs');
      const today = new Date(this.dateFunctions.formatDate(new Date(), DATE_TIME_FORMAT.COMMON_DATE_FORMAT2));
      for (let i = 0; i < this.billsList.length; i++) {
        if (new Date(this.dateFunctions.formatDate(new Date(this.billsList[i].bill_datetime), DATE_TIME_FORMAT.COMMON_DATE_FORMAT2)) >= today) {
          this.upcomingList.push(this.billsList[i]);
        }
      }
      this.upcomingList = this.util.cloneDeep(this.upcomingList);
    } catch (error) {
      this.util.logFunc('toFilterUpcomingLs', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  private toGetCategoryList(categoryList) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toGetCategoryList');
      this.categorySliderList = categoryList.sort((a, b) =>
        a.categoryname.toLowerCase() > b.categoryname.toLowerCase() ? 1 : -1
      );
      for (let i = 0; i < this.categorySliderList.length; i++) {
        this.categorySliderList[i]['isSelected'] = false;
      }
      let categoryObj = {
        categoryid: CategoryFilter.All,
        categoryname: 'All',
        isSelected: true,
      };
      this.categorySliderList.splice(0,0,categoryObj);
    } catch (error) {
      this.util.logFunc('toGetCategoryList', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onClickBill(bill: any) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onClickBill');
        if (bill.bill.repeat_interval != RepeatInterval.ONE_TIME) {
          this.isRepeatBill = true;
        } else {
          this.isRepeatBill = false;
        }
        this.billStatus = bill.payment_status ? APP_ROUTES.PAID : APP_ROUTES.UNPAID;
        this.openBillModal = true;
        this.selBill = bill;
    } catch (error) {
      this.util.logFunc('onClickBill', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onEditBill() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onEditBill');
      if(BASE_CONFIG.IS_GUEST_USER){
       this.util.openGuestUserModal();
      }else{
      this.openBillModal = false;
      this.modalController.dismiss();
      this.store.dispatch(new BillDetail(this.selBill));
      this.util.navigate(APP_ROUTES.ADD_BILL, { id: this.selBill.bill_id , repeatBill: this.isRepeatBill });
      }
    } catch (error) {
      this.util.logFunc('onEditBill', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onClickMarkAsPaid() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onClickMarkAsPaid');
      // var popover = await this.popoverController.create({
      //   component:IonDateTimePickerComponent,
      //   id : 'paymentDate' ,
      //   componentProps : {
      //     parent : this ,
      //     propsData : {
      //       maxDate : this.dateFunctions.formatDate(new Date(),DATE_TIME_FORMAT.API_DATE_FORMAT1),
      //       minDate : "1970-01-01",
      //       title : $localize`:@@dashboard-selectPaymentDate:Select payment date`
      //     },
      //     onDateSel : this.onDatePicked.bind(this)
      //   },
      //   cssClass : 'paid-picker'
      // });
      //   await popover.present();
      //   document.body.classList.add('date-modal');

      (document.getElementById('paid-picker') as any).showPicker();
    } catch (error) {
      this.util.logFunc('onClickMarkAsPaid', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  async onDatePicked(event)
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log("onDatePicked");
      // this.popoverController.dismiss(undefined,undefined,'paymentDate');
      if (event.target.value) {
        this.markAsPaid(this.dateFunctions.formatDate(event.target.value , DATE_TIME_FORMAT.API_DATE_FORMAT1) as string);
      }
    } catch (error) {
      this.util.logFunc('onDatePicked', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  markAsPaid(paidDate: string) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('markAsPaid');
      let billsQuery = this.queryFunction.getMarkAsPaidQuery();
      let s = this.apollo
        .mutate({
          mutation: gql`
            ${billsQuery}
          `,
          errorPolicy: 'all',
          variables: {
            id: this.selBill.id,
            paid_amount: this.selBill.amount,
            payment_status: 1,
            paid_date: paidDate,
          },
        })
        .subscribe((result: any) => {
          if (result.data.update_billsreminder_bill_details) {
            this.util.toShowToast(
              $localize`:@@bill-markAsPaid:Success! The bill has been marked as paid`,
              ToastTypes.Success
            );
            this.assignStatus();
          } else if (result && result.errors) {
            this.util.handleErrorStatus(
              COMPONENT_NAME.BILLS_LIST_PAGE,
              'markAsPaid',
              result.errors[0].message.toString()
            );
            this.util.errorHandling(result.errors);
          }
          this.closeModal();
        });
    } catch (error) {
      this.util.logFunc('markAsPaid', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onClickDelete() 
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onClickDelete');
      this.alertMsg = this.isRepeatBill ? $localize`:@@dashboard-deleteRepeatedBillsConfirmMsg:Are you sure want to delete this Repeated Bills?` : $localize`:@@dashboard-deleteConfirmMsg:Are you sure want to delete this Bill?`;
      this.modalStatus = AlertModalStatus.confirm;
      this.toggleAlertModal();
    } catch (error) {
      this.util.logFunc('onClickDelete', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  deleteBill() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('deleteBill');
      let billsQuery = this.queryFunction.deleteBillQuery(this.selBill.id);
      let s = this.apollo
        .mutate({
          mutation: gql`
            ${billsQuery}
          `,
          errorPolicy: 'all',
        })
        .subscribe((result: any) => {
          if (result.data.delete_billsreminder_bill_details) {
            this.util.toShowToast(
              $localize`:@@bill-deleteBill:The bill has been deleted`,
              ToastTypes.Success
            );
            this.assignStatus();
          } else if (result && result.errors) {
            this.util.handleErrorStatus(
              COMPONENT_NAME.BILLS_LIST_PAGE,
              'deleteBill',
              result.errors[0].message.toString()
            );
            this.util.errorHandling(result.errors);
          }
          this.closeModal();
        });
    } catch (error) {
      this.util.logFunc('deleteBill', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  deleteRecurringBill() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('deleteRecurringBill');
      let billsQuery = this.queryFunction.deleteRepeatedBillQuery(
        this.selBill
      );
      let s = this.apollo
        .mutate({
          mutation: gql`
            ${billsQuery}
          `,
          errorPolicy: 'all',
        })
        .subscribe((result: any) => {
          if (result.data.delete_billsreminder_bill_details) {
            this.util.toShowToast(
              $localize`:@@bill-deleteBill:The bill has been deleted`,
              ToastTypes.Success
            );
            this.assignStatus();
          } else if (result && result.errors) {
            this.util.handleErrorStatus(
              COMPONENT_NAME.BILLS_LIST_PAGE,
              'deleteRecurringBill',
              result.errors[0].message.toString()
            );
            this.util.errorHandling(result.errors);
          }
          this.closeModal();
        });
    } catch (error) {
      this.util.logFunc('deleteRecurringBill', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onAlertModalClose(isConfirm): void {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onAlertModalClose');
      this.alertMsg = null;
      this.modalStatus = null;
      if (isConfirm == true) {
        if (this.isRepeatBill) {
          this.deleteRecurringBill()
        } else {
          this.deleteBill();
        }
      }
      this.toggleAlertModal();
    } catch (error) {
      this.util.logFunc('onAlertModalClose', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  toggleAlertModal(): void {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toggleAlertModal');
      this.showAlertModal = !this.showAlertModal;
    } catch (error) {
      this.util.logFunc('toggleAlertModal', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  closeModal() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('closeModal');
      this.openBillModal = false;
      this.modalController.dismiss();
    } catch (error) {
      this.util.logFunc('closeModal', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

  onClearFilter()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onClearFilter');
      this.selStartDate = this.startDate;
      this.selEndDate = this.endDate;
      this.searchBoxValue = '';
      setTimeout(() => {
        this.selStartDate = this.defaultStartDate;
        this.selEndDate = this.defaultEndDate;
        this.showDateClearBtn = false;
      });
    } catch (error) {
      this.util.logFunc('onClearFilter', error, COMPONENT_NAME.DASHBOARD_PAGE);
    }
  }

}
